export default {
    common: {
      username: 'username',
      password: 'password',
      save: 'Save',
      edit: 'Edit',
      update: 'Update',
      delete: 'Delete',
      forever: 'Forever',
      expired: 'Expired'
    },
    "login.login.443414-0": "Login",
    "login.login.443414-1": "Please enter a username",
    "login.login.443414-2": "Please enter a password",
    "login.login.443414-3": "Remember the password",
    "login.login.443414-4": "Change the password",
    "login.login.443414-5": "Account",
    "login.login.443414-6": "Please enter",
    "login.login.443414-7": "Original password",
    "login.login.443414-8": "New password",
    "login.login.443414-9": "Confirm the password",
    "login.login.443414-10": "Cancel",
    "login.login.443414-11": "Confirm",
    "login.login.443414-12": "Scan the code to download the App",
    "login.login.443414-13": "Android scan code to download",
    "login.login.443414-14": "IOS WeChat scan code access",
    "login.login.443414-15": "China gas and electrical intelligent safety monitoring and control platform",
    "login.login.443414-16": "Xinder gas and electrical intelligent safety monitoring and control platform",
    "login.login.443414-17": "Power safety management platform",
    "login.login.443414-18": "The account is logged in elsewhere",
    "login.login.443414-19": "Please fill in the required fields first!",
    "login.login.443414-20": "The user name cannot be empty!",
    "login.login.443414-21": "Password cannot be empty!"
    
}


// WEBPACK FOOTER //
// ./src/i18n/lang/En/login-en.js